import React from 'react';
import Icon from 'components/AppIcon';

const LoadingSpinner = ({ size = 40, message = "Loading..." }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-100">
      <div className="flex flex-col items-center space-y-4">
        <div className="relative">
          <Icon 
            name="Loader" 
            size={size} 
            className="text-primary animate-spin" 
          />
          <div className="absolute inset-0 rounded-full border-2 border-primary/20 animate-pulse"></div>
        </div>
        <p className="font-body text-text-secondary text-lg">{message}</p>
        <div className="w-16 h-1 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-primary to-accent rounded-full animate-pulse w-1/2"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner; 